/**
 * Curated, ordered 661-level allow-list for Masters League difficulty phase 2.
 *
 * Source: "Final Ordered Levels" tab, column `level` in `position` order:
 * https://docs.google.com/spreadsheets/d/1UlsBKUxfqOrDuWCjoP3mMFHjnKZIQy7cXv7TMV-09ms
 * (pulled 2026-07-22; 661 unique levels, range 103-4596).
 *
 * The list is played in order using the persistent league cursor and wraps
 * without reshuffling. Levels 496, 500, 753 and 841 were excluded from the
 * retired randomized pool but are deliberate inclusions here.
 */
export const leaguePhase2Allowlist: readonly number[] = [
  4005, 4073, 3329, 4399, 4401, 2563, 2475, 4351, 2449, 3910, 4452, 4526, 4084,
  1695, 4171, 4264, 3555, 2929, 4031, 1599, 176, 1154, 3745, 4406, 4451, 331,
  315, 4263, 3526, 4204, 4055, 4137, 1660, 4485, 2681, 990, 4254, 3105, 1939,
  3319, 4515, 1111, 2827, 4573, 1900, 2379, 4402, 4003, 4207, 4559, 3993, 503,
  533, 4168, 4226, 3992, 817, 841, 4556, 2543, 524, 2010, 4321, 3477, 4563,
  4443, 3419, 662, 3713, 1999, 3855, 299, 4567, 3824, 4260, 4444, 847, 3059,
  2150, 4106, 409, 4233, 1713, 1479, 3682, 4453, 1973, 4027, 4534, 1913, 4459,
  1129, 1078, 3041, 616, 3174, 4454, 3051, 1240, 3996, 1641, 2018, 1493, 4557,
  4356, 395, 877, 2735, 3641, 3837, 3479, 4189, 407, 656, 4538, 4045, 2360,
  2341, 2075, 4009, 4015, 2273, 2989, 1430, 178, 3591, 3953, 469, 4496, 318,
  764, 973, 2231, 1577, 4529, 3123, 1789, 4548, 4588, 4155, 1731, 3061, 668,
  4296, 2701, 2411, 2439, 545, 2429, 3764, 2904, 4154, 4159, 2069, 2521, 3098,
  4543, 4019, 759, 239, 2004, 1080, 2045, 1960, 3218, 518, 4491, 1294, 4502,
  4593, 4222, 4245, 3665, 2997, 4253, 350, 4437, 3989, 363, 257, 4587, 4152,
  3179, 4507, 3255, 4113, 1935, 3243, 4388, 3507, 4528, 3883, 4071, 4368, 1336,
  4004, 4481, 865, 4385, 2536, 3807, 3932, 2055, 3399, 2733, 2649, 4037, 4180,
  4122, 4142, 3655, 1707, 4145, 3435, 4392, 2809, 4352, 3404, 4297, 224, 2236,
  4503, 3487, 3213, 3943, 4197, 4247, 4090, 4479, 681, 4446, 1241, 4395, 4577,
  2727, 4102, 4221, 4286, 4463, 2746, 4293, 1115, 3081, 1369, 609, 2893, 4476,
  2065, 2734, 1119, 4505, 2606, 1193, 4083, 3203, 753, 3207, 976, 3944, 4553,
  2625, 3000, 647, 4229, 4121, 4533, 4323, 104, 3508, 4596, 4537, 4461, 2651,
  1885, 4501, 240, 4052, 262, 1397, 4337, 2791, 2525, 4456, 4405, 2795, 145,
  2477, 4131, 1706, 4367, 1691, 4347, 4549, 2541, 4099, 4490, 2451, 3715, 4215,
  3304, 2113, 4359, 4492, 4475, 3977, 1031, 1556, 1918, 3103, 2951, 2223, 4576,
  3558, 4449, 1557, 881, 4471, 4486, 396, 2921, 4565, 4329, 426, 4191, 370,
  2119, 345, 3775, 3813, 1652, 2914, 4302, 2033, 2375, 502, 3899, 442, 2760,
  4579, 982, 1147, 3478, 1539, 4249, 491, 2977, 735, 4425, 4371, 4504, 495,
  1792, 3457, 3633, 468, 4420, 1168, 1239, 2639, 1131, 236, 814, 2259, 4198,
  974, 1542, 2071, 4252, 473, 2719, 4139, 1756, 2480, 3204, 1335, 3115, 1122,
  4566, 705, 4589, 543, 343, 1610, 3897, 571, 3954, 3185, 4278, 2333, 2983,
  3163, 4546, 1319, 275, 3843, 4053, 3959, 4158, 2305, 4365, 663, 2969, 4301,
  4381, 425, 2567, 4217, 4075, 784, 4105, 2955, 589, 440, 3229, 954, 1869, 3355,
  4569, 2749, 4429, 4143, 4306, 2765, 287, 432, 2813, 1526, 1605, 1341, 2025,
  3363, 2861, 4251, 3523, 2325, 1837, 815, 4531, 2225, 4163, 1595, 2213, 4185,
  4407, 4190, 4110, 883, 1656, 2121, 3951, 3525, 2847, 4517, 1777, 4460, 2971,
  4103, 4409, 4514, 1775, 293, 2923, 4434, 500, 4147, 1799, 3527, 1192, 4123,
  1738, 4002, 4275, 1050, 4283, 3209, 3958, 2241, 639, 1537, 4209, 1176, 4465,
  4497, 4575, 335, 3499, 3806, 3680, 3707, 3193, 4285, 4411, 1075, 4220, 2009,
  3089, 3975, 3447, 3909, 4322, 4310, 1531, 4065, 3783, 1705, 646, 2707, 329,
  1185, 655, 4341, 3384, 1299, 4086, 3653, 2661, 741, 4487, 783, 1965, 496,
  1585, 2089, 4521, 709, 1551, 4023, 1384, 2359, 4590, 2687, 2453, 509, 3371,
  478, 4167, 3815, 2629, 2507, 1737, 476, 4506, 1455, 2175, 4477, 1852, 436,
  4006, 1281, 1127, 3765, 3131, 360, 189, 745, 2825, 1663, 985, 2086, 1106,
  3761, 3747, 2685, 4378, 1822, 4499, 548, 3475, 2349, 3389, 4267, 2347, 1894,
  422, 4580, 1625, 103, 691, 3173, 4353, 1242, 4360, 1221, 4376, 799, 1786,
  2792, 4261, 711, 1066, 1821, 3352, 4350, 2799, 4424, 4493, 2357, 1915, 4442,
  3366, 1583, 2881, 4287, 4342, 4011, 4489, 1609, 4591, 340, 4124, 1235, 1169,
  4427, 3893, 1089, 4120, 3777, 566, 501, 1956, 1895, 1481, 1521, 1453, 755,
  4134, 4242, 4419, 245, 4560, 3237, 3949, 4472, 3985, 3601, 3053, 1751, 3551,
  4101, 775, 4281, 3981, 2147, 2109, 2841, 447, 1141, 1690, 4391, 4574, 229,
  3251, 2691, 347, 2675, 2293, 2101, 3331, 1745, 559, 1114,
];
